/**
 * WI 34037 - web-only flags on the shared `IDynamicModelOptions`, declared as a module augmentation (the same
 * pattern as the NativeScript `modal-host.utils.ts`) because `models/dynamic.interface.ts` is over the 500-line
 * file gate. The web radio and safety-at-risk templates already read these; strictTemplates needs them declared.
 */
declare module '@ups/xplat/dynamic-render' {
  interface IDynamicModelOptions {
    /** Hide the control's own label (radio, safety-at-risk). Default off. */
    ignoreLabel?: boolean;
  }
}

export {};
